export default "__VITE_ASSET__BNj3d8$L__"